import { OnInit, EventEmitter } from '@angular/core';
import { InputComboService } from '../services/input-combo.service';
import { Globals } from '../objects/Globals';
import { WorkspaceService } from '../services/workspace.service';
var InputComboComponent = /** @class */ (function () {
    function InputComboComponent(inputComboService, globals, workspaceService) {
        this.inputComboService = inputComboService;
        this.globals = globals;
        this.workspaceService = workspaceService;
        this.comboList = [];
        this.selectedComboIdChanged = new EventEmitter();
    }
    Object.defineProperty(InputComboComponent.prototype, "createNewCombo", {
        set: function (any) {
            var _this = this;
            var type = "UserDepartmentList";
            this.inputComboService.createInputComboCard(type).subscribe(function (id) {
                if (id) {
                    _this.comboId = id;
                    _this.inputComboService.getInputComboList(id).subscribe(function (result) {
                        var inputCombo = JSON.parse(result);
                        _this.setDefaultValue(inputCombo);
                    });
                }
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputComboComponent.prototype, "inputComboFilter", {
        set: function (filter) {
            var _this = this;
            if (filter) {
                var type = "UserDepartmentList";
                this.inputComboService.createInputComboCard(type).subscribe(function (id) {
                    if (id) {
                        _this.comboId = id;
                        _this.inputComboService.getInputComboList(id, filter).subscribe(function (result) {
                            if (result) {
                                var inputCombo = JSON.parse(result);
                                _this.setDefaultValue(inputCombo);
                            }
                        });
                    }
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputComboComponent.prototype, "setComboId", {
        set: function (id) {
            var _this = this;
            this.comboId = id;
            if (this.comboId) {
                this.previousComboId = this.comboId;
                this.inputComboService.getInputComboList(this.comboId).subscribe(function (result) {
                    if (result) {
                        var inputCombo = JSON.parse(result);
                        _this.setDefaultValue(inputCombo);
                    }
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    InputComboComponent.prototype.ngOnInit = function () {
    };
    InputComboComponent.prototype.getList = function () {
    };
    InputComboComponent.prototype.setDefaultValue = function (inputCombo) {
        var _this = this;
        var i = 0;
        inputCombo.forEach(function (element) {
            if (i == 0)
                element.IsSelected = true;
            if (element.IsSelected) {
                _this.selectedCombo = element.SelectionValue;
            }
            i++;
        });
        this.selectedComboIdChanged.emit(this.selectedCombo); //probably no need or need
        this.comboList = inputCombo;
    };
    InputComboComponent.prototype.onValueChange = function (item) {
        this.selectedComboIdChanged.emit(item.SelectionValue);
    };
    return InputComboComponent;
}());
export { InputComboComponent };
